import { Show, type JSX } from "solid-js";

type Props = {
  count: () => number;
  onClear: () => void;
  // Action buttons rendered inline. Use plain buttons so callers can
  // style/disable them independently.
  children: JSX.Element;
};

// Sticky toolbar that appears above a list when one or more rows are selected.
// Always opaque against the page background and on top of subsequent content,
// so it's reachable while scrolling a long list.
export function SelectionActionBar(props: Props) {
  return (
    <Show when={props.count() > 0}>
      <div
        role="toolbar"
        aria-label={`${props.count()} row${props.count() === 1 ? "" : "s"} selected`}
        class="sticky top-16 z-20 bg-base-100 border border-base-300 rounded-lg shadow-sm px-3 py-2 flex items-center gap-3"
      >
        <span class="text-sm font-medium">
          {props.count()} selected
        </span>
        <div class="flex items-center gap-2 flex-wrap">{props.children}</div>
        <button
          type="button"
          class="btn btn-ghost btn-xs ml-auto"
          onClick={props.onClear}
        >
          Clear
        </button>
      </div>
    </Show>
  );
}
